// initial state
import docendo from '../../docendo'

const moment = extendMoment(Moment)
import Vue from 'vue'
import {extendMoment} from 'moment-range'
import Moment from 'moment'
import eventbus from '../../eventbus'

const state = {
  allUsers: [],
  allUsersAndEvents: null,
  allEvents: [],
  allEventsInAHash: {},
  allEventsWithMultipleTeachersOn: {},
  allCalsWithEventIdsInHash: {},
  allAbsenceEventInEventSerialIdsHash: {},
  date: moment().utc(),
  activeEvent: null,
  activeUser: null,
  schedulerActiveEvent: {'left': 0, 'right': 0, color: ''},
  absenceReasons: [],
  longAbsentList: [],
  isSortSubActive: false,
  sortSubs: 0,
  usersAndSubstituteHours: {},
  dataIsLoading: false,
  sortingHierarchy: {
    othersOnLesson: 0,
    isInSameClassAtTheSameTime: 3,
    availableHour: 6,
    presence: 9,
    multipleLessonsInSameClasses: 12,
    notOccupiedWithLessonsOnDay: 15,
    notOccupiedWithoutLessonsOnDay: 18,
    occupied: 21,
    absence: 24
  },
  activeAbsenceReason: null,
  isActiveAbsenceReasonIsReadyToDelete: false,
  activeAbsentUser: null,
  activeAbsentUserEvents: [],
  activeAbsentUserOriginalEvents: []
}

const getters = {
  allUsersSortedOnName: (state) => {
    const removeNullFromUsers = state.allUsers.filter(user => user.name !== null && user.name !== '')
    return Vue.prototype.$helpers.sortArrOnName(removeNullFromUsers)
  },
  allUsersSortedIds: (state, getters) => getters.allUsersSortedOnName.map(user => user.user_calendar_id),
  userSet: (state, getters) => getters.allUsersSortedIds.map(userId => state.allUsersAndEvents[userId]),
  absentUsersFromUserSet: (state, getters) => getters.userSet.filter(user => user.dayAbsence.length > 0),
  substitutesToday: (state, getters) => getters.userSet.filter(user => user.daySubEvents.length > 0),
  absentUsersGetDate: (state) => moment(state.date).format('YYYY_MM_DD'),
  absentUsersHandledHash: (state, getters) => {
    let hash = {}

    getters.absentUsersFromUserSet.forEach(user => {
      // 0 = none, 1 = handled, 2 = pending
      let userStatus = 1
      let isAnyEventsPending = false

      for (const dayAbsence of user.dayAbsence) {
        // Hent dagens events og filtrer events fra andre skoler væk
        const userEvents = user.dayEvents
          .map(dayEventId => state.allEventsInAHash[dayEventId])
          .filter(dayEvent => dayEvent && !dayEvent.v_is_event_from_other_school)

        // Tjek om brugeren ingen events har den dag, men status er ændret til 0
        if (userEvents.length === 0) {
          const absence = state.allEventsInAHash[dayAbsence] || {}
          const subStatus = absence.substitution_status ? JSON.parse(absence.substitution_status) : {}
          const status =
            subStatus[user.user_calendar_id] && subStatus[user.user_calendar_id].status !== undefined
              ? subStatus[user.user_calendar_id].status
              : 1
          if (status === 0) {
            userStatus = 0
            break // Tidligt exit - ingen grund til at tjekke videre
          }
        }

        // Tjek status for events
        for (const lesson of userEvents) {
          const absence = state.allEventsInAHash[dayAbsence] || {}
          const normalizedStart = moment(absence.start).millisecond(0)
          const normalizedEnd = moment(absence.end).millisecond(0)
          const absenceRange = moment.range(normalizedStart, normalizedEnd)
          const lessonRange = moment.range(lesson.start, lesson.end)

          if (absenceRange.overlaps(lessonRange)) {
            const subStatus = lesson.substitution_status ? JSON.parse(lesson.substitution_status) : {}
            const status =
              subStatus[user.user_calendar_id] && subStatus[user.user_calendar_id].status !== undefined
                ? subStatus[user.user_calendar_id].status
                : 0
            if (status === 2) {
              isAnyEventsPending = true
            }

            const isUserSubstituted = lesson.calendar_events.some(
              function (calEvent) {
                return calEvent.substitute_for_user_id === user.id
              }
            )

            if (!isUserSubstituted && status === 0) {
              userStatus = 0
              break // Tidligt exit - ingen grund til at tjekke videre
            }
          }
        }
      }
      hash[user.id] = userStatus === 1 && isAnyEventsPending ? 2 : userStatus
    })

    return hash
  },
  absentUsersUnhandled: (state, getters) => {
    return getters.absentUsersFromUserSet.filter(user => {
      return !getters.absentUsersHandledHash[user.id]
    })
  },
  absentUsersHandled: (state, getters) => {
    return getters.absentUsersFromUserSet.filter(user => {
      return getters.absentUsersHandledHash[user.id]
    })
  },
  notAbsentUsersFromUserSet: (state, getters) => getters.userSet.filter(user => user.dayAbsence.length < 1),
  subsAbsenceReasonsSorted (state, getters) {
    return state.absenceReasons.sort((a, b) => {
      let nameA = a.name.toUpperCase().trim() // ignore upper and lowercase
      let nameB = b.name.toUpperCase().trim() // ignore upper and lowercase
      if (nameA < nameB) return -1
      if (nameA > nameB) return 1
      return 0
    })
  },
  longAbsentListInHash: (state, getters) => state.longAbsentList.reduce((obj, item) => {
    obj[item.id] = item
    return obj
  }, {}),
  usersWithOngoingAbsenceInHash: (state, getters) => {
    // let users = {1231: {absenceArr: [12, 33]}},
    let users = {}
    state.longAbsentList.filter(absence => absence.ongoing).forEach(absence => {
      if (!users[absence.calendar_id]) {
        Vue.set(users, absence.calendar_id, {absenceArr: [absence.id]})
      } else {
        users[absence.calendar_id].absenceArr.push(absence.id)
      }
    })
    return users
  },
  activeAbsentUserEventsInHash: (state, getters) => state.activeAbsentUserEvents.reduce((obj, item) => {
    obj[item.event_id] = item
    return obj
  }, {}),
  activeAbsentUserOriginalEventsInHash: (state, getters) => state.activeAbsentUserOriginalEvents.reduce((obj, item) => {
    obj[item.event_id] = item
    return obj
  }, {})
}

const mutations = {
  setSubDate (state, date) {
    state.date = moment(date).format('YYYY-MM-DD')
  },
  setAllUsers: (state, data) => {
    console.time('create User Arr')
    state.allUsers = data
    let users = state.allUsers
    let allUsers = users.reduce((obj, item) => {
      let substituteHours = 0
      let subPolsDiff = 0
      if (item.current_user_year) {
        if (item.current_user_year.substitute_pool_hours) {
          subPolsDiff = item.current_user_year.substitute_pool_hours
        }
        if (state.usersAndSubstituteHours[item.id]) {
          substituteHours = state.usersAndSubstituteHours[item.id].toFixed(1)
          subPolsDiff = subPolsDiff - state.usersAndSubstituteHours[item.id]
        }
      }
      Vue.set(item, 'dayEvents', [])
      Vue.set(item, 'daySubEvents', [])
      Vue.set(item, 'dayAbsence', [])
      Vue.set(item, 'dayPresence', [])
      Vue.set(item, 'dayAllEvents', [])
      Vue.set(item, 'subPoolsDiff', subPolsDiff)
      Vue.set(item, 'substituteHours', substituteHours)
      Vue.set(item, 'dayAvailability', [])
      Vue.set(item, 'v_two_in_class_events', [])
      Vue.set(item, 'v_two_events_in_class_events', [])
      obj[item.user_calendar_id] = item
      return obj
    }, {})
    state.allUsersAndEvents = allUsers
    console.timeEnd('create User Arr')
  },
  addEventOnAllUsersWithEvents: (state, data) => {
    state.allUsersAndEvents[data.cal_id].dayEvents.push(data.event_id)
  },
  addANewEvent: (state, lesson) => {
    state.allEvents.push(lesson)
    state.allEventsInAHash[lesson.id] = lesson
    lesson.calendar_events.forEach(user => {
      // Only push into users
      if (state.allUsersAndEvents[user.calendar_id]) {
        state.allUsersAndEvents[user.calendar_id].dayEvents.push(lesson.id)
      }
    })
  },
  addAbsenceToUserInAllUsersWithEvents: (state, data) => {
    state.allUsersAndEvents[data.cal_id].dayAbsence.push(data.event_id)
  },
  removeAbsenceOnAllUsersWithEvents: (state, data) => {
    let idx = state.allUsersAndEvents[data.cal_id].dayAbsence.indexOf(data.event_id)
    state.allUsersAndEvents[data.cal_id].dayAbsence.splice(idx, 1)
  },
  removeEventOnAllUsersWithEvents: (state, data) => {
    let idx = state.allUsersAndEvents[data.cal_id].dayEvents.indexOf(data.event_id)
    state.allUsersAndEvents[data.cal_id].dayEvents.splice(idx, 1)
  },
  setAllEvents (state, data) {
    state.allEvents = data
    let events = state.allEvents
    state.allEventsInAHash = events.reduce((obj, item) => {
      obj[item.id] = item
      return obj
    }, {})
  },
  updateEventOnAllEventsInAHash (state, event) {
    Vue.set(state.allEventsInAHash, event.id, event)
  },
  updateTeacherNoteOnEvent (state, eventIdAndTeacherNote) {
    state.allEventsInAHash[eventIdAndTeacherNote.eventId].teacher_notes = eventIdAndTeacherNote.note
  },
  updateAllEventsWithMultipleTeachersOn (state, data) {
    Vue.set(state.allEventsWithMultipleTeachersOn, data.userAndEventIds, data.userCalIds)
  },
  updateSubStatusOnEvent (state, eventIdAndsubstitutionStatus) {
    state.allEventsInAHash[eventIdAndsubstitutionStatus.eventId].substitution_status = eventIdAndsubstitutionStatus.status
  },
  setActiveUser (state, data) {
    state.activeUser = data
  },
  setActiveEvent (state, data) {
    state.activeEvent = data
  },
  subsSetAbsenceReasons (state, data) {
    state.absenceReasons = data
  },
  subsAddNewAbsenceReason (state, data) {
    state.absenceReasons.push(data)
  },
  subsSetLongAbsentList (state, data) {
    state.longAbsentList = data
  },
  setIsSubScoreActive (state, boolean) {
    state.isSortSubActive = boolean
  },
  setUsersWithSubPools (state, data) {
    state.usersAndSubstituteHours = data
  },
  setSortSubsAgain () {
    state.sortSubs++
  },
  setCalsInAllCalsAndEvents (state, data) {
    Vue.set(state.allCalsWithEventIdsInHash, data.calid, {lessons: [data.eventid]})
  },
  addEventInAllCalsAndEvents (state, data) {
    state.allCalsWithEventIdsInHash[data.calid].lessons.push(data.eventid)
  },
  setSortingHierarchy (state, obj) {
    // Run trough each prop because obj doesn't include absence, occupied etc.
    Object.entries(obj).forEach(([key, value]) => {
      state.sortingHierarchy[key] = value
    })
  },
  setActiveAbsenceReason (state, obj) {
    state.activeAbsenceReason = obj
  },
  updateLongListAbsence (state, data) {
    let idx = state.longAbsentList.findIndex(absence => absence.id === data.id)
    Vue.set(state.longAbsentList, idx, data)
  },
  deleteLongListAbsenceItem (state, eventSerial) {
    let idx = state.longAbsentList.findIndex(absence => absence.id === eventSerial.eventSerialId)
    if (idx > -1) {
      state.longAbsentList.splice(idx, 1)
    }
  },
  setIsActiveAbsenceReasonIsReadyToDelete (state, boolean) {
    state.isActiveAbsenceReasonIsReadyToDelete = boolean
  },
  setActiveAbsentUser (state, user) {
    state.activeAbsentUser = user
  },
  setActiveAbsentUserEvents (state, events) {
    state.activeAbsentUserEvents = events
  },
  setActiveAbsentUserOriginalEvents (state, events) {
    state.activeAbsentUserOriginalEvents = events
  },
  setAllEventsOnUsers (state, data) {
    console.time('vuex::setAllEventsOnUsers')
    const filterReservations = data.filter(event => event.event_type !== 'reservation')
    let allEvents = filterReservations
    this.commit('setAllEvents', filterReservations)

    let usersWithEvents = state.allUsersAndEvents
    for (const key of Object.keys(usersWithEvents)) {
      Vue.set(usersWithEvents[key], 'dayAllEvents', [])
      Vue.set(usersWithEvents[key], 'dayEvents', [])
      Vue.set(usersWithEvents[key], 'daySubEvents', [])
      Vue.set(usersWithEvents[key], 'dayAbsence', [])
      Vue.set(usersWithEvents[key], 'dayPresence', [])
      Vue.set(usersWithEvents[key], 'subScore', [0, 0, 0])
      Vue.set(usersWithEvents[key], 'dayAvailability', [])
      Vue.set(usersWithEvents[key], 'v_two_in_class_events', [])
      Vue.set(usersWithEvents[key], 'v_two_events_in_class_events', [])
    }

    // Ryd events for alle kalendere
    state.allCalsWithEventIdsInHash = {}
    state.allAbsenceEventInEventSerialIdsHash = {}
    // Opret kort over klasseevents baseret på `klassId`
    const klassEventsMap = {}
    // Gennemgå alle events og organisér dem efter klasse og tidspunkt
    for (let i = 0; i < allEvents.length; i++) {
      const event = allEvents[i]
      const klassEvents = event.calendar_events.filter(ce => ce.calendar_type === 'klass')

      klassEvents.forEach(klassEvent => {
        const klassId = klassEvent.calendar_id
        const start = event.start
        const end = event.end

        if (!klassEventsMap[klassId]) {
          klassEventsMap[klassId] = []
        }

        // Se om der allerede er en lektion med samme tid for denne klasse
        const overlapping = klassEventsMap[klassId].find(existingEvent =>
          existingEvent.start === start && existingEvent.end === end
        )
        klassEventsMap[klassId].push({start, end, event})
        if (overlapping) {
          // console.log(event.title + ' overlapper med ' + overlapping.event.title)
          overlapping.event.calendar_events.forEach(calEvent => {
            const userCalId = calEvent.calendar_id
            const user = usersWithEvents[userCalId]
            if (calEvent.calendar_type === 'user' && user) {
              usersWithEvents[userCalId].v_two_events_in_class_events.push(overlapping.event.id)
              usersWithEvents[userCalId].v_two_events_in_class_events.push(event.id)
            }
          })
          event.calendar_events.forEach(calEvent => {
            const userCalId = calEvent.calendar_id
            const user = usersWithEvents[userCalId]
            if (calEvent.calendar_type === 'user' && user) {
              const userCalId = calEvent.calendar_id
              usersWithEvents[userCalId].v_two_events_in_class_events.push(overlapping.event.id)
              usersWithEvents[userCalId].v_two_events_in_class_events.push(event.id)
            }
          })
        }
      })
    }
    // Gennemgå alle events for brugerne
    for (let i = 0; i < allEvents.length; i++) {
      const event = allEvents[i]
      if (event.calendar_events) {
        // Kontroller for to lærere og én klasse i dette event
        const userCount = event.calendar_events.filter(ce => ce.calendar_type === 'user').length
        const hasKlass = event.calendar_events.some(ce => ce.calendar_type === 'klass')
        const hasTwoOrMoreTeachersInClass = userCount > 1 && hasKlass

        for (let j = 0; j < event.calendar_events.length; j++) {
          const calendarEvent = event.calendar_events[j]
          const calId = calendarEvent.calendar_id

          // Tilføj event til "specialEvents", hvis kriterierne er opfyldt
          if (hasTwoOrMoreTeachersInClass && usersWithEvents[calId]) {
            usersWithEvents[calId].v_two_in_class_events.push(event.id)
          }

          // Tilføj til alle cals og lessonids
          if (state.allCalsWithEventIdsInHash[calId]) {
            this.commit('addEventInAllCalsAndEvents', {
              calid: calId,
              eventid: event.id
            })
          } else {
            this.commit('setCalsInAllCalsAndEvents', {
              calid: calId,
              eventid: event.id
            })
          }

          // Tilføj event til brugerens specifikke kategorier
          if (usersWithEvents[calId]) {
            state.allUsersAndEvents[calId].dayAllEvents.push(event.id)
            if (event.event_type === 'absence' || event.away) {
              state.allUsersAndEvents[calId].dayAbsence.push(event.id)
              if (event.event_serial_id) {
                Vue.set(state.allAbsenceEventInEventSerialIdsHash, event.event_serial_id, event)
              }
            } else if (event.event_type === null || event.event_type === 'presence') {
              state.allUsersAndEvents[calId].dayPresence.push(event.id)
            } else {
              if (event.event_type === 'available') {
                state.allUsersAndEvents[calId].dayAvailability.push(event.id)
              }
              state.allUsersAndEvents[calId].dayEvents.push(event.id)
            }

            // Find substitutes Today
            if (calendarEvent.substitute_for_user_id) {
              state.allUsersAndEvents[calId].daySubEvents.push(event.id)
            }
          }
        }
      }
    }

    let usersWithEventsInArry = Object.keys(usersWithEvents).map(key => {
      return usersWithEvents[key]
    })
    state.usersWithEvents = usersWithEventsInArry
    state.dataIsLoading = false
    console.timeEnd('vuex::setAllEventsOnUsers')
  }
}

const actions = {
  getAllUsers: (context, schoolId, userIdsFilter) => {
    docendo.schoolUsers(window.SCHOOL.id, userIdsFilter, (data) => {
      context.commit('setAllUsers', data)
    })
  },
  readAllEvents: (context, storeObj) => {
    const activeSchoolId = window.SCHOOL.id * 1
    const events = []
    context.state.dataIsLoading = true
    docendo.listEventsForSchools(storeObj.schoolIds, moment(context.state.date).format('YYYY-MM-DD'), data => {
      if (data.status === 'error') {
        // If user is not member of both schools
        context.dispatch('getAllDayEvents')
      } else {
        const parsedData = JSON.parse(data)
        parsedData.forEach(event => {
          const idx = events.findIndex(lesson => lesson.id === event.id)
          if (idx < 0) {
            if (!storeObj.isShowEventsFromOtherThanActiveSchool && (event.school_id * 1) !== activeSchoolId) {
              Vue.set(event, 'v_is_event_from_other_school', true)
            }
            events.push(event)
          }
        })
        context.commit('setAllEventsOnUsers', events)
      }
    }, failure => {
      // If the user is not member of the other school
      window.alert('Something went wrong')
      context.state.dataIsLoading = false
      context.commit('setAllEventsOnUsers', events)
    })
  },
  getAllDayEvents: (context) => {
    context.state.dataIsLoading = true
    docendo.listEvents(window.SCHOOL.id, moment(context.state.date).format('YYYY-MM-DD'), data => {
      context.commit('setAllEventsOnUsers', JSON.parse(data))
    })
  },
  getUserSubPools: (context) => {
    docendo.schoolSubstituteHours(window.SCHOOL.id, data => {
      context.commit('setUsersWithSubPools', data)
    })
  },
  subsGetAbsenceReasons: (context) => {
    docendo.schoolAbsenceSubjectsList(window.SCHOOL.id, false, data => {
      context.commit('subsSetAbsenceReasons', data)
    })
  },
  subsGetLongAbsenceList: (context) => {
    docendo.schoolEventSerialsList(window.SCHOOL.id, context.state.date, data => {
      context.commit('subsSetLongAbsentList', data)
    })
  },
  setActiveSchedulerEvent: (context, data) => {
    context.state.schedulerActiveEvent = data
    if (!context.state.isSortSubActive || !data.userIsAbsent || data.obj.event_type === 'absence') {
      return
    }
    console.time('subScore')
    let overlappingEvents = {
      absence: {},
      available: {},
      presence: {},
      severalOnLesson: {},
      lessonsInSameClass: {},
      lessons: {},
      multipleLessonsInSameClasses: {}
    }
    let otherOnlessonHash = {}
    let overlappingLessonsInClassHash = {}

    // "Også tilknyttet"
    if (data.othersOnLesson) {
      otherOnlessonHash = data.othersOnLesson.reduce((obj, item) => {
        obj[item.user_calendar_id] = item
        return obj
      }, {})
    }
    if (data.overlappingEvents) {
      data.overlappingEvents.forEach(event => {
        switch (event.event_type) {
          case 'absence':
            event.calendar_events.forEach(cal => {
              overlappingEvents.absence[cal.calendar_id] = cal.calendar_id
            })
            break
          case 'available':
            event.calendar_events.forEach(cal => {
              overlappingEvents.available[cal.calendar_id] = cal.calendar_id
            })
            break
          case 'presence':
            let overlapping = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]')
            event.calendar_events.forEach(cal => {
              if (overlapping) {
                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id
              }
            })
            break
          case null:
            let overlap = moment(context.state.schedulerActiveEvent.obj.start).isBetween(event.start, event.end, null, '[]') && moment(context.state.schedulerActiveEvent.obj.end).isBetween(event.start, event.end, null, '[]')
            event.calendar_events.forEach(cal => {
              if (overlap) {
                overlappingEvents.presence[cal.calendar_id] = cal.calendar_id
              }
            })
            break
          default:
            event.calendar_events.forEach(cal => {
              let arrOfCalIdsOnActiveEvent = context.state.schedulerActiveEvent.obj.calendar_events.map(cal => cal.calendar_id)
              // Er på en anden brik i klassen på samme tid
              if (event.id !== context.state.schedulerActiveEvent.obj.id && arrOfCalIdsOnActiveEvent.indexOf(cal.calendar_id) > -1) {
                event.calendar_events.forEach(cal => {
                  overlappingEvents.lessonsInSameClass[cal.calendar_id] = cal.calendar_id
                })
                // Look up overlapping cal type?
                // if (context.rootGetters['allCalendarsInHash'][cal.calendar_id] && context.rootGetters['allCalendarsInHash'][cal.calendar_id]) {}
              }

              // overlappingLessonsInClassHash = {klasse: [eventid, eventid], 122: [332211]}
              if (context.rootGetters.allKlassCalendarsInHash[cal.calendar_id]) {
                if (!overlappingLessonsInClassHash[cal.calendar_id]) {
                  overlappingLessonsInClassHash[cal.calendar_id] = [event.id]
                } else {
                  overlappingLessonsInClassHash[cal.calendar_id].push(event.id)
                }
              }
              if (context.state.allUsersAndEvents[cal.calendar_id]) {
                // See if +2 on lesson && other is not absent
                if (context.state.allEventsWithMultipleTeachersOn[cal.calendar_id + '_' + event.id]) {
                  overlappingEvents.severalOnLesson[cal.calendar_id] = cal.calendar_id
                } else {
                  overlappingEvents.lessons[cal.calendar_id] = cal.calendar_id
                }
              }
            })
            break
        }
      })
    }
    // Lav array om til bruger_id'er
    // Find de props, hvor der er mere end 1 i
    Object.entries(overlappingLessonsInClassHash).forEach((eventIds, key) => {
      if (eventIds[1].length > 1) {
        eventIds[1].forEach(eventId => {
          context.state.allEventsInAHash[eventId].calendar_events.forEach(cal => {
            if (context.state.allUsersAndEvents[cal.calendar_id]) {
              overlappingEvents.multipleLessonsInSameClasses[cal.calendar_id] = eventIds[0]
            }
          })
        })
      }
    })

    context.state.allUsers.forEach(user => {
      context.state.allUsersAndEvents[user.user_calendar_id].subScore = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      let subScoreTags = 0
      let subScoreSubPools = 0 // user.subPoolsDiff * 0.01 > 0 ? user.subPoolsDiff * 0.01 : 0
      if (!data.user) {
        return
      }
      // Tags
      data.user.user_tags.forEach(userTag => {
        user.user_tags.forEach(subTag => {
          if (subTag === userTag) {
            subScoreTags < 10 ? subScoreTags++ : null
          }
        })
      })
      // "Også tilknyttet"
      if (otherOnlessonHash[user.user_calendar_id]) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.othersOnLesson + 2] = subScoreSubPools
      }

      // Er i samme klasse på samme tidspunkt
      if (overlappingEvents.lessonsInSameClass[user.user_calendar_id]) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.isInSameClassAtTheSameTime + 2] = subScoreSubPools
      }

      // Er to eller flere i en anden klasse på samme tidspunk
      if (overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id]) {
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = overlappingEvents.multipleLessonsInSameClasses[user.user_calendar_id] // the klassCalId so two users from same class is next to eachother
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools
      }

      if (overlappingEvents.lessons[user.user_calendar_id]) {
        // IKke noget hvis optaget
      } else if (overlappingEvents.severalOnLesson[user.user_calendar_id]) {
        // hvis 2 på en lektion
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses] = 1
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 1] = subScoreTags
        context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.multipleLessonsInSameClasses + 2] = subScoreSubPools
      } else {
        // Ikke optaget && "Rådighedstime"
        if (overlappingEvents.available[user.user_calendar_id]) {
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.availableHour + 2] = subScoreSubPools
        }
        // Ikke optaget && "Tilstedeværelse"
        if (overlappingEvents.presence[user.user_calendar_id]) {
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.presence + 2] = subScoreSubPools
        }
        // Ikke optaget m. lektioner på dagen u. overlappende tilstedeværelse
        if (context.state.allUsersAndEvents[user.user_calendar_id].dayEvents.length > 0) {
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithLessonsOnDay + 2] = subScoreSubPools
        } else {
          // Ikke optaget u. lektioner på dagen u. overlappende tilstedeværelse
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay] = 1
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 1] = subScoreTags
          context.state.allUsersAndEvents[user.user_calendar_id].subScore[context.state.sortingHierarchy.notOccupiedWithoutLessonsOnDay + 2] = subScoreSubPools
        }
      }
      // TO string
      context.state.allUsersAndEvents[user.user_calendar_id].subScore = context.state.allUsersAndEvents[user.user_calendar_id].subScore.join('')
    })
    context.state.sortSubs++
    console.timeEnd('subScore')
  },
  updateIsSubZenActive (context, boolean) {
    context.commit('setIsSubScoreActive', boolean)
    context.dispatch('updateUserSettings', {'isSubZenActive': boolean})
  },
  updateSortingHierarchy (context, obj) {
    let userSettingsObj = {'subZenOrder': obj}
    context.dispatch('updateUserSettings', userSettingsObj)
    context.commit('setSortingHierarchy', obj)
  },
  updateEventsSerial (context, obj) {
    docendo.schoolEventSerialsUpdate(window.SCHOOL.id, obj.id, obj.calendar_id, obj.subject_id, obj.from_date, obj.to_date, obj.from_time, obj.to_time, obj.ongoing, obj.internal_note, success => {
      context.commit('updateLongListAbsence', JSON.parse(success))
      context.dispatch('getAllDayEvents')
      eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_updated'), 'success': true}
    }, failure => {
      console.log('failed', failure)
    })
  },
  removeSubsFromEvents (context, obj) {
    const statusData = {}
    statusData[obj.user_calendar_id] = {'status': 0}
    const userId = obj.userId

    // Group events by school_id
    const eventsObj = {}
    obj.events.forEach(event => {
      if (!eventsObj[event.school_id]) {
        eventsObj[event.school_id] = [event]
      } else {
        eventsObj[event.school_id].push(event)
      }
    })

    // Iterate over each school_id and make API call to remove substitutions
    Object.keys(eventsObj).forEach(prop => {
      const schoolId = Number(prop)  // Convert prop to a number
      const eventIds = eventsObj[prop].map(event => event.event_id)

      // Call API to remove substitutions for the user
      docendo.removeSubstitutionOfUser(schoolId, eventIds, userId, statusData, success => {
        const data = success.length > 0 ? JSON.parse(success) : []

        data.forEach(event => {
          // Check if the event is on the same day
          if (moment(event.start).format('YYYY_MM_DD') === moment(context.state.date).format('YYYY_MM_DD')) {
            let eventBeforeUpdate = context.state.allEventsInAHash[event.id]
            context.commit('updateEventOnAllEventsInAHash', event)
            let diffCals = eventBeforeUpdate.calendar_events.filter(o => !event.calendar_events.some(i => i.id === o.id))
            // Remove events from all users i substitution
            diffCals.forEach(cal => {
              context.commit('removeEventOnAllUsersWithEvents', {
                cal_id: cal.calendar_id,  // Identify the calendar ID
                event_id: event.id
              })
            })
          }
        })
        eventbus.toast = {
          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_removed'),
          success: true
        }
      }, failure => {
        console.log('API call failure:', failure)

        eventbus.toast = {
          text: window.use_i18n.t('vue2.subs_ongoing_absence.subs_remove_failed'),
          success: false
        }
      })
    })
  },
  deleteAbsence (context, reasonObj) {
    if (reasonObj.event_serial_id) {
      docendo.schoolEventSerialsDelete(window.SCHOOL.id, reasonObj.event_serial_id, (success) => {
        context.commit('removeAbsenceOnAllUsersWithEvents', {
          cal_id: reasonObj.user_calendar_id,
          event_id: reasonObj.id
        })
        context.commit('deleteLongListAbsenceItem', {
          eventSerialId: reasonObj.event_serial_id
        })
        eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true}
      })
    } else {
      docendo.deleteEvent(window.SCHOOL.id, reasonObj.id, data => {
        context.commit('removeAbsenceOnAllUsersWithEvents', {
          cal_id: JSON.parse(data).calendar_id,
          event_id: JSON.parse(data).id
        })
        eventbus.toast = {text: window.use_i18n.t('vue2.subs_ongoing_absence.absence_deleted'), 'success': true}
      })
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/subs.js